import React, { FC } from 'react';
import { TableCell, TableRow } from '@mui/material';

type CategoryItemProps = {
    category: { _id: string; name: string };
    onCategoryRowClick: (category: { _id: string; name: string }) => void;
};

const CategoryItem: FC<CategoryItemProps> = ({ category, onCategoryRowClick }: CategoryItemProps) => {
    return (
        <TableRow hover sx={{ cursor: 'pointer' }} onClick={() => onCategoryRowClick(category)}>
            <TableCell>{category.name}</TableCell>
        </TableRow>
    );
};

export default CategoryItem;
